import moment from 'moment';
import { SeminarModel } from '../models/seminar.model';

export function getLocationString(
  seminar: SeminarModel,
  useLineBreaks: boolean = false,
  shortForm: boolean = false
): string {
  if (seminar.modality === 'online') {
    return 'Online';
  }
  let separator = useLineBreaks ? '\n' : ', ';
  let tooltip = '';

  if (!seminar.address) {
    return '';
  }

  if (seminar.address.title && !shortForm) {
    tooltip += seminar.address.title + separator;
  }
  if (seminar.address.street) {
    tooltip += seminar.address.street + ' ';
  }
  if (seminar.address.houseNumber) {
    tooltip += seminar.address.houseNumber + separator;
  }
  if (seminar.address.zip) {
    tooltip += seminar.address.zip + ' ';
  }
  if (seminar.address.city) {
    tooltip += seminar.address.city + separator;
  }
  if (seminar.address.country && !shortForm) {
    tooltip += seminar.address.country;
  }
  return tooltip.trim().replace(/,\s*$/, '');
}

export function getCourseDate(seminar: SeminarModel): string {
  if (seminar.dateSeries.length === 0) {
    return '';
  }

  // Parse and sort dates to ensure they're in chronological order
  const sortedDates = seminar.dateSeries
    .flatMap(series => series.dates)
    .sort((a, b) => {
      return moment(a.startDate).diff(moment(b.startDate));
    });

  // Check if dates are consecutive
  let consecutive = true;
  for (let i = 1; i < sortedDates.length; i++) {
    const diff = moment(sortedDates[i].startDate).diff(
      sortedDates[i - 1].startDate,
      'days'
    );
    if (diff !== 1) {
      consecutive = false;
      break;
    }
  }

  if (consecutive) {
    // If dates are consecutive, return as a range
    const startDate = moment(sortedDates[0].startDate).format('DD.MM.');
    const endDate = moment(
      sortedDates[sortedDates.length - 1].startDate
    ).format('DD.MM.YYYY');
    return `${startDate} - ${endDate}`;
  } else {
    // If not, return joined by commas
    return sortedDates
      .map(date => moment(date.startDate).format('DD.MM.YYYY'))
      .join(', ');
  }
}

export function getFobiPoints(seminar: SeminarModel): number {
  return seminar.dateSeries
    .flatMap(series => series.dates.map(date => date.fobiPoints))
    .reduce((acc, val) => acc + val, 0);
}

export function getCourseDuration(startDate: Date, endDate: Date): string {
  if (!startDate || !endDate) {
    return null;
  }
  const duration = moment.duration(moment(endDate).diff(moment(startDate)));
  const hours = String(duration.hours()).padStart(2, '0');
  const minutes = String(duration.minutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
}
